export enum Screens {
  loading = 'loading',
  homeScreen = 'homeScreen',
}
